import { axiosAPI } from 'utils';

const fallbackError = (err) => {
  console.error(err);
  return err?.response?.data || { success: false, error: err?.message || 'Request failed' };
};

export default {
  get() {
    return axiosAPI
      .get('api/admin/elevenlabs-settings')
      .then((res) => res.data)
      .catch(fallbackError);
  },

  update(params) {
    return axiosAPI
      .put('api/admin/elevenlabs-settings', params)
      .then((res) => res.data)
      .catch(fallbackError);
  },

  getVoices() {
    return axiosAPI
      .get('api/admin/elevenlabs-settings/voices')
      .then((res) => res.data)
      .catch(fallbackError);
  },
};
